import { render, staticRenderFns } from "./MenuSlider.vue?vue&type=template&id=28064a5e&"
import script from "./MenuSlider.vue?vue&type=script&lang=js&"
export * from "./MenuSlider.vue?vue&type=script&lang=js&"
import style0 from "./MenuSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports